module.exports = __webpack_public_path__ + "img/pay_arrivals.a833d9d3.png";